// extracted by mini-css-extract-plugin
export var bd = "ar-u";
export var bigger = "ar-x";
export var detail = "ar-w";
export var downloadBar = "ar-t";
export var footBottom = "ar-s";
export var footBottomDesc = "ar-z";
export var footLine = "ar-q";
export var footTop = "ar-n";
export var footTopAddress = "ar-r";
export var footTopDesc = "ar-o";
export var footTopText = "ar-p";
export var footerM = "ar-m";
export var ft = "ar-A";
export var logo = "ar-v";
export var minWidthLimit = "ar-l";
export var red = "ar-y";